<template>
  <div class="page-course-class-notice">
    <div class="class-notice-list outer">
      <div v-for="(item, index) in list"
           :key="index"
           class="class-notice-list-content"
      >
        {{ item.content }}
        <div v-for="(item2, index2) in item.list"
             :key="index2"
             class="class-notice-list"
        >
          <div class="class-notice-list-content item2">
            {{ item2.content }}
          </div>
          <div v-for="(item3, index3) in item2.list"
               :key="index3"
               class="class-notice-list"
          >
            <div class="class-notice-list-content item3">
              {{ item3.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getCourseNotice } from '@/services/course';

  export default {
    name: 'CourseClassNotice',
    metaInfo: {
      title: '课前须知',
    },
    data() {
      return {
        list: [],
      };
    },
    methods: {
      async fetchData(id) {
        const data = await getCourseNotice(id);
        this.list = data.list;
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(id);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-course-class-notice {
    background-color: #fff;
    padding-top: 40px;
    min-height: 100%;
  }

  .class-notice-list {
    &.outer {
      margin-bottom: 40px;
      padding: 0 30px;
    }
    &-content {
      color: @color-black-dark;
      font-size: 34px;
      font-weight: bold;
      margin-bottom: 10px;
      &.item2 {
        color: #666;
        font-size: 28px;
        padding-left: 15px;
      }
      &.item3 {
        color: #666;
        font-size: 24px;
        font-weight: normal;
        padding-left: 15px;
      }
    }
  }
</style>
